export default "__VITE_ASSET__C7lwiA2x__"